import React from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import values from '../../values/values'

function RowContainerItem({minWidth, margin, style, children}) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <div style={{
                flex: 1, 
                minWidth: minWidth ? minWidth : 200, 
                margin: margin ? margin : values.margin[2],
                boxSizing: 'border-box',
                ...style,
                ...(isMobile ? {
                    flex: '1 1 auto',
                    width: '100%',
                    minWidth: 0,
                    maxWidth: '100%',
                    marginLeft: 0,
                    marginRight: 0,
                } : {}),
                }}>
            {children}
        </div>
    );
}

export default RowContainerItem;
